import React, { useContext, useMemo, useState, useCallback, useRef } from 'react';
import { CToast, CToastBody, CToastClose, CToaster } from '@coreui/react-pro';

const Toast = ({ message, color = 'primary', autohide = true }) => (
    <CToast autohide={autohide} color={color} visible className="text-white align-items-center">
        <div className="d-flex">
            <CToastBody style={{ color: 'black' }}>{message}</CToastBody>
            <CToastClose className="me-2 m-auto c-gray-base" />
        </div>
    </CToast>
);

const TOAST_CONTEXT = React.createContext(null);

const useToastContext = () => useContext(TOAST_CONTEXT);

const ToastProvider = ({ children }) => {
    const [toast, addToast] = useState(0);
    const toaster = useRef();

    const sendToast = useCallback(
        (message, color, autohide) => addToast(<Toast message={message} color={color} autohide={autohide} />),
        [],
    );

    const value = useMemo(
        () => ({
            sendToast,
        }),
        [sendToast],
    );
    return (
        <TOAST_CONTEXT.Provider value={value}>
            {children}
            <CToaster style={{ zIndex: 999999999 }} ref={toaster} push={toast} placement="bottom-center" />
        </TOAST_CONTEXT.Provider>
    );
};

export { useToastContext };
export default ToastProvider;
